module.exports = __webpack_public_path__ + "img/13200.fc7bebd7.jpg";